import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "next-intl";
import Link from "next/link";

export default function BackToLogin() {
  const t = useTranslations("ForgotPassword");

  return (
    <div
      className="flex items-center justify-center gap-2 pt-2.5 text-gray-500"
      dir="ltr"
    >
      <ArrowLeftIcon className="h-3.5 w-3.5" />
      <Link href="/auth" className="text-sm">
        {t("back_to_login")}
      </Link>
    </div>
  );
}
